export default __webpack_public_path__ + "static/server-2eebd9b53020aa786c268187f0e80a9a.jpg";